module.exports = __webpack_public_path__ + "img/a42a4c9.jpg";